import React from "react";
import PropTypes from "prop-types";
import PortfoliosBlue from "rialto-icons/PortfoliosBlue";

import styles from "./PortfolioToggle.css";

const PortfolioToggle = ({ onClick }) => (
  <div className={styles.brand} onClick={onClick}>
    <PortfoliosBlue size="large" />
  </div>
);

PortfolioToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default PortfolioToggle;
